import { useEffect } from 'react';

export default function ScheduleMeeting() {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const scripts = document.querySelectorAll('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      scripts.forEach(s => s.remove());
    };
  }, []);

  return (
    <section
      style={{
        padding: "60px 20px",
        background: "#f8fdf8",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "42px",
            fontWeight: "700",
            marginTop:"50px",
            marginBottom: "16px",
            color: "#111",
          }}
        >
          Schedule a Meeting
        </h1>

        <p
          style={{
            fontSize: "18px",
            color: "#555",
            marginBottom: "40px",
          }}
        >
          Choose a convenient date and time to connect with G.M. Narendra.
        </p>

        <div
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
            background: "#fff",
            padding: "20px",
          }}
        >
          {/* Calendly Inline Widget */}
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/narendragm03/30min"
            style={{
              minWidth: "320px",
              height: "700px",
            }}
          />
        </div>
      </div>
    </section>
  );
}